export const hasTargetThatCanBeDisabled = ( event: UIEvent ): event is HasTargetThatCanBeDisabled => {
    return typeof event === 'object'
        && event != null
        && typeof event.target === 'object'
        && event.target != null
        && 'disabled' in event.target
        && typeof ( event.target as TargetCanBeDisabled ).disabled === 'boolean';
};

interface HasTargetThatCanBeDisabled extends UIEvent {
    target: TargetCanBeDisabled;
}

interface TargetCanBeDisabled extends EventTarget {
    disabled: boolean;
}
